import { useMutation } from '@tanstack/react-query';
import { APITypes } from '../../primary-record-types';
import { appAPI } from '../../utils/api';
import urls from '../../utils/urls';
import { useIsUserLoggedIn } from '../useIsUserLoggedIn';
import Constants from 'expo-constants';

const isRunningInExpoGo = Constants.appOwnership === 'expo';

export type ReportedError = APITypes.errorService.ReportErrorRequest & {
    url: string | null;
    errorInfo: string | null;
};

export type UseReportErrorReturnValue = {
    reportError: (error: ReportedError) => void;
};

export default function useReportError(): UseReportErrorReturnValue {
    const { isUserLoggedIn } = useIsUserLoggedIn();
    const reportErrorMutation = useMutation({
        mutationFn: async (error: ReportedError) => {
            if (!isUserLoggedIn) {
                console.error('User is not logged in, not reporting error');
                return;
            }

            if (isRunningInExpoGo || true) return;

            return await appAPI.post(urls.api.errors.reportError, {
                body: error,
            });
        },
        onError: (e) => {
            console.error('Error reporting error', e);
        },
    });

    return {
        reportError: reportErrorMutation.mutate,
    };
}
